import {
  MONITOR_TYPE_LOAD,
  MONITOR_TYPE_LOAD_SUCCESS,
  MONITOR_TYPE_ERROR,
  MONITOR_TYPE_CLEAN,

} from "./actionTypes"
import dictionary from "../../../config/dictionary"
export const monitorTypeError = error => {
  return {
    type: MONITOR_TYPE_ERROR,
    payload: error,
  }
}
export const initLoadTypesMonitor = (filter) => {
  return {
    type: MONITOR_TYPE_LOAD,
    payload: filter,
  }
}

export const loadTypes = types => {

  types.forEach(c => {
    c.label = c.name
    c.text = c.value
    c.value = c.code
  })

  const ls = types.filter(item => item.code !== dictionary.configApp.type.orderDisable)
  ls.unshift({ label: 'TODOS', text: '', value: '' })
  return {
    type: MONITOR_TYPE_LOAD_SUCCESS,
    payload: ls,
  }
}

export const cleanTypes = () => {
  return {
    type: MONITOR_TYPE_CLEAN,
    payload: {},
  }
}